import React from 'react'
import { Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { settingsService } from '@/lib/services/settings'
import { useAuth } from '@/contexts/AuthContext'
import { useRoleDetection } from '@/hooks/useRoleDetection'

// /foh/directors exists only for Directors (level 4+) and admins, and only once the store has
// switched the board on (Settings → Directors). Everyone else lands on the FOH board.
export default function DirectorBoardGate({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  const { isDirector } = useRoleDetection()
  const { data: settings, isLoading } = useQuery({ queryKey: ['settings'], queryFn: settingsService.getSettings })
  if (isLoading) return null
  const allowed = (isDirector || user?.role === 'admin') && !!settings?.directorBoard?.enabled
  if (!allowed) return <Navigate to="/foh" replace />
  return <>{children}</>
}
